import { types } from 'mobx-state-tree';

import CartNewProductType from '../../types/CartNewProductType';
import OrderTotalClass from '../../types/order/OrderTotalClass';
import ProductTypeClass from '../../types/ProductTypeClass';
import OrderAlerts from '../order/OrderAlerts';
import OrderTotalValue from '../order/OrderTotalValue';
import CartBasket from './CartBasket';
import CartProduct from './CartProduct';

const Cart = types.compose(
  OrderAlerts,
  types.model('Cart', {
    baskets_and_templates: types.array(CartBasket),
    expires_at: types.maybeNull(types.string),
    new_products: types.array(CartProduct),
    number_of_products: types.number,
    products: types.array(CartProduct),
    removed_products: types.array(CartProduct),
    selected_basket_id: types.maybeNull(types.string),
    show_cart_error_modal: types.optional(types.boolean, false),
    show_product_code: types.boolean,
    total_weight: types.maybeNull(types.string),
    totals: types.maybeNull(types.map(OrderTotalValue))
  }))
  .named("Cart")
  .views((self) => ({
    get allTotals() {
      return self.totals ? [...self.totals.values()] : [];
    },
    get getPhysicalProducts() {
      return self.products.filter(
        (product) => product.type === ProductTypeClass.PHYSICAL
      );
    },
    get ifRenderModal() {
      return self.new_products.length > 0;
    },
    // Used after Arinet/PartStream redirect when add was blocked (e.g. sideregister miss)
    get ifRenderErrorModal() {
      return self.show_cart_error_modal === true;
    },
    get newProduct() {
      return self.new_products.length > 0 && self.new_products[0];
    },
    get newProductIsBundle() {
      // User can add a mix of products in their my-account page and if by chance first in the list is bundle product
      // cart title would display "Product bundle added to cart"
      return self.new_products.length === 1 && self.new_products[0].cart_type === CartNewProductType.BUNDLE;
    },
    get productsTotal() {
      return self.totals?.size > 0 && self.totals.get(OrderTotalClass.PRODUCTS_TOTAL) || null;
    },
    get total() {
      return self.totals?.size > 0 && self.totals.get(OrderTotalClass.TOTAL) || null;
    },
    get totalAddedProduct() {
      let quantity = 0;
      if (self.new_products.length > 1) {
        quantity = self.new_products.reduce((sum, product) => sum + product.added_quantity, 0);
      } else if (self.new_products.length === 1) {
        quantity = self.new_products[0].added_quantity;
      }

      return {
        quantity,
        unit: self.new_products.length > 0 ? self.new_products[0].stock_unit : '',
      }
    }
  }));

export default Cart;
